<template>
  <Chart :options="options" ref="lineCharts"></Chart>
</template>

<script>
import {Chart} from 'highcharts-vue'
export default {
  name: 'SubscribedCountLineChartComponent',
  components: {
    Chart
  },
  data () {
    return {
      options: {
        chart: {
          type: 'line'
        },
        title: {
          text: 'Subscribed Count'
        },
        xAxis: {
          categories: []
        },
        yAxis: {
          title: {
            text: 'Count'
          },
          labels: {
            formatter: function () {
              return this.value
            }
          }
        },
        tooltip: {
          crosshairs: true,
          shared: true
        },
        credits: {
          enabled: true
        },
        plotOptions: {
          line: {
            marker: {
              radius: 4,
              lineColor: '#808080',
              lineWidth: 1
            }
          }
        },
        series: [
          {
            name: 'Beeline',
            color: '#20a8d8',
            marker: {
              symbol: 'circle'
            },
            data: []
          },
          {
            name: 'Ucell',
            color: '#4dbd74',
            marker: {
              symbol: 'circle'
            },
            data: []
          }
        ]
      }
    }
  },
  created () {
    this.doRequest()
  },
  methods: {
    doRequest (params) {
      this.axios.get('dashboard/line-chart')
        .then(({data}) => {
          if (data.data) {
            this.updateChart(data.data.lineCategory, data.data.lineBeeline, data.data.lineUcell)
          }
        }).catch(() => {
          this.$toastr.error('Internal server error')
        })
    },
    updateChart (categies, series1, series2) {
      this.options.xAxis.categories = categies
      this.options.series[0].data = series1
      this.options.series[1].data = series2
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dashboard/SubscribedCountLineChartComponent.vue